'use strict';
const angular = require('angular');

export class weatherWidgetComponent {

  constructor() {
    'ngInject';
  }

  $onInit() {
   this.unit = this.unit || 'f';
  }
}

export default angular.module('conduuApp.weatherWidget', [])
  .component('weatherWidget', {
    template: `<weather location="{{$ctrl.location}}" unit="{{$ctrl.unit}}"></weather>`,
    bindings: {
     location: '@',
     unit: '@'
    },
    controller: weatherWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/weather-widget/weather-widget.component.js